import styled from 'styled-components';

export const StyledItemLoading = styled('div')`
  min-height: 40px;
  display: flex;
  align-items: center;
`;
